import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import AddressSection from './components/AddressSection';
import FaxSettingsView from './components/FaxSettingsView';
import { displayPhoneNumber } from './displayPhoneNumber';
import { IClinic } from '@customTypes/clinician';

interface ClinicDetailsViewProps {
  clinic: IClinic;
  onEdit: () => void;
  verificationStatus: 'idle' | 'pending' | 'success' | 'error';
  verificationMessage: string;
  verificationCode: string;
  onVerificationCodeChange: (val: string) => void;
  onSubmitVerification: () => void;
  onResendCode: () => void;
}

export default function ClinicDetailsView({
  clinic,
  onEdit,
  verificationStatus,
  verificationMessage,
  verificationCode,
  onVerificationCodeChange,
  onSubmitVerification,
  onResendCode,
}: ClinicDetailsViewProps) {
  return (
    <div className='clinic-details-container'>
      <div className='d-flex justify-content-end mb-3'>
        <Button variant='outline-primary' size='sm' onClick={onEdit}>
          <FontAwesomeIcon icon={faPencil} className='me-2' />
          Edit
        </Button>
      </div>

      <div className='details-grid'>
        <div className='detail-item'>
          <span className='label'>Organization name</span>
          <span className='value'>{clinic.name}</span>
        </div>
        <div className='detail-item'>
          <span className='label'>Phone</span>
          <span className='value'>{displayPhoneNumber(clinic.phone)}</span>
        </div>
      </div>

      <div className='mt-4 view-mode-extensions'>
        <AddressSection
          isEditing={false}
          address={clinic.address}
          streetFocused={false}
          onStreetFocus={() => {}}
          onStreetBlur={() => {}}
          onChange={() => {}}
          onAddressSelect={() => {}}
        />

        <FaxSettingsView
          fax={clinic.fax || ''}
          isFaxEnabled={clinic.is_fax_enabled || false}
          faxVerified={clinic.fax_number_verified || false}
          verificationStatus={verificationStatus}
          verificationMessage={verificationMessage}
          verificationCode={verificationCode}
          onVerificationCodeChange={onVerificationCodeChange}
          onSubmitVerification={onSubmitVerification}
          onResendCode={onResendCode}
        />
      </div>
    </div>
  );
}
